var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2232_106827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.702 9.93555L0 15.7028L0.297958 22.0001L25 16.2328L24.702 9.93555Z",
    fill: "#FFE900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59021 6.56116V9.3194H13.4247C12.5389 11.6308 10.8501 13.1259 8.894 13.1259C8.03871 13.1239 7.19707 12.9125 6.44359 12.5104C5.6901 12.1083 5.048 11.5278 4.57407 10.8205C4.10014 10.1131 3.809 9.30052 3.72642 8.45473C3.64385 7.60893 3.77237 6.7559 4.10062 5.97121C4.42887 5.18653 4.94673 4.4943 5.60838 3.95581C6.27002 3.41731 7.05507 3.04915 7.894 2.8839C8.733 2.71864 9.6 2.76139 10.4184 3.00836C11.2368 3.25532 11.9813 3.69889 12.586 4.29981L14.5581 2.34053C13.4425 1.23059 12.0207 0.474289 10.4725 0.16729C8.92435 -0.139716 7.31928 0.01637 5.86037 0.615799C4.40146 1.21523 3.15425 2.23107 2.27651 3.53484C1.39877 4.83861 0.92991 6.37175 0.929253 7.94028C0.925403 8.98053 1.12955 10.0111 1.52986 10.9723C1.93017 11.9335 2.51865 12.8061 3.26115 13.5395C3.99935 14.2789 4.87698 14.8664 5.84387 15.2687C6.81077 15.6709 7.848 15.8799 8.89614 15.8836C11.6148 15.8836 14.0596 14.1447 15.5029 11.3832V15.5526H18.2791V6.56116H9.59021Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2232_106827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoto);
export default __webpack_public_path__ + "static/media/goto.5a5263c84526c3f9145b1d66e43ed71f.svg";
export { ForwardRef as ReactComponent };